import { render, staticRenderFns } from "./course-xp.vue?vue&type=template&id=0bfc4ebe&scoped=true&"
import script from "./course-xp.vue?vue&type=script&lang=js&"
export * from "./course-xp.vue?vue&type=script&lang=js&"
import style0 from "./course-xp.vue?vue&type=style&index=0&id=0bfc4ebe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc4ebe",
  null
  
)

export default component.exports